export default "__VITE_ASSET__60e14992__"